import { render, staticRenderFns } from "./PayInfoBox.vue?vue&type=template&id=6ad4d216&scoped=true"
import script from "./PayInfoBox.vue?vue&type=script&lang=js"
export * from "./PayInfoBox.vue?vue&type=script&lang=js"
import style0 from "./PayInfoBox.vue?vue&type=style&index=0&id=6ad4d216&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad4d216",
  null
  
)

export default component.exports